/**
 * 入参：
 * legendColspan：每个小时分成几格，默认2格
 * lineFeedSplit：页面显示的时间段分隔符，默认是"~"
 *
 */

define('directives/common/dayschedule/day.schedule.directives',['app'], function (app) {
    app.directive('daySchedule', function () {
        var timeout;
        return {
            restrict: 'E',
            scope: {
                conf: "="
            },
            replace: true,
            require: "?ngModel",
            templateUrl: '../refactor/directives/common/dayschedule/day.schedule.template.html',
            link: function ($scope, element, attrs, ngModelCtrl) {
                if (!$scope.conf.id) {
                    $scope.conf.id = 'daySchedule_' + Math.ceil(Math.random() * 100000);
                }
                element.find('div').attr("id", $scope.conf.id);
                element.find('textarea').attr("id", $scope.conf.id + '_data_target');
                element.ready(function () {
                });
                ngModelCtrl.$formatters.push(function (modelValue) {
                    var DaySchedule2 = new UCD.DaySchedule('#' + $scope.conf.id, {
                        data: getFromModelValue(modelValue),
                        lineFeedSplit: $scope.conf.lineFeedSplit ? $scope.conf.lineFeedSplit : "~",
                        //表头合并单元格数
                        legendColspan: $scope.conf.legendColspan ? $scope.conf.lineFeedSplit : 2,
                        xlabels: ["00:00~01:00", "01:00~02:00", "02:00~03:00", "03:00~04:00", "04:00~05:00", "05:00~06:00", "06:00~07:00", "07:00~08:00", "08:00~09:00", "09:00~10:00", "10:00~11:00", "11:00~12:00",
                            "12:00~13:00", "13:00~14:00", "14:00~15:00", "15:00~16:00", "16:00~17:00", "17:00~18:00", "18:00~19:00", "19:00~20:00", "20:00~21:00", "21:00~22:00", "22:00~23:00", "23:00~24:00"],
                        onSelection: function (e, $selections, selectionMode, context, content) {
                            angular.element('#' + $scope.conf.id + '_data_target').val($.map(context.getData()[0].Content, function (v, i) {
                                return v.StartTime + '~' + v.EndTime;
                            }).join('\n'));
                            setToModelValue(context.getData()[0].Content);
                        },
                        //默认以秒钟seconds计算，所以需要格式化
                        format: function (v) {
                            return (Math.floor(v / 3600) < 10 ? "0" + Math.floor(v / 3600) : Math.floor(v / 3600)) + ":" + (new Array(2).join('0') + (v % 3600 / 60)).slice(-2);
                        },
                        //反格式化成秒钟
                        unFormat: function (v) {
                            var timeArr = v.split(':');
                            return (timeArr[0].indexOf('0') == 0 ? parseInt(timeArr[0].charAt(1)) : timeArr[0]) * 3600 + timeArr[1] * 60;
                        }
                    });
                });
                function getFromModelValue(modelValue) {
                    // [['03:00','03:30'],['08:30','12:30'],['14:00','23:00']]
                    var data = [{
                        "serial": 1,
                        "Content": []
                    }];
                    for (var i in modelValue) {
                        data[0].Content.push({
                            StartTime: modelValue[i][0],
                            EndTime: modelValue[i][1]
                        })
                    }
                    return data;
                }

                function setToModelValue(list) {
                    var result = [];
                    if (list && list.length > 0) {
                        for (var i in  list) {
                            var tempTime = [];
                            tempTime[0] = list[i].StartTime;
                            tempTime[1] = list[i].EndTime;
                            result.push(tempTime);
                        }
                    }
                    ngModelCtrl.$setViewValue(result);
                }
            }
        }
    });
});
